import Vue from 'vue'
import Router from 'vue-router'

//自定义页面
import Index from '@/views/index'
import Cars from '@/views/cars'
import Series from '@/views/series'
import Mall from '@/views/mall'
import News from '@/views/news'
import Article from '@/views/article'
import Quote from '@/views/quote'
import Dealer from '@/views/dealer'
import NewCars from '@/views/newCars'

//安装路由到vue
Vue.use(Router)

const routes = [{
        path: '/',
        name: 'Index',
        component: Index
    }, {
        path: '/cars',
        name: 'NewCars',
        component: NewCars
    }, {
        path: '/series/:id',
        name: 'Series',
        component: Series
    }, {
        path: '/mall',
        name: 'Mall',
        component: Mall
    }, {
        path: '/news',
        name: 'News',
        component: News
    }, {
        path: '/article/:id',
        name: 'Article',
        component: Article
    }, {
        path: '/quote',
        name: 'Cars',
        component: Cars
    },
    {
        path: '/dealers',
        name: 'Dealers',
        component: Dealer
    },
    {
        path: '/quote/askprice',
        name: 'Quote',
        component: Quote
    },
]

export default new Router({
    //mode: 'hash', //默认hash模式，hash模式有#；另外还有一种history模式，没有#符号
    mode: 'history',
    routes
})